<ng-container *ngIf="gatewayConfig$ | async as cfg">
  <div
    class="row min-length"
    *ngIf="cfg.merchant.passwordSecurity.minLength > 0"
    [class.success]="
      password && password.length >= cfg.merchant.passwordSecurity.minLength
    "
  >
    <span class="yes icon">
      <i class="fas fa-check"></i>
    </span>
    <span class="no icon">
      <i class="fas fa-times"></i>
    </span>
    <span>
      {{
        "general.password.errors.minLength"
          | translate: { value: cfg.merchant.passwordSecurity.minLength }
      }}
    </span>
  </div>
  <div
    class="row max-length"
    *ngIf="cfg.merchant.passwordSecurity.maxLength > 0"
    [class.success]="
      password && password.length <= cfg.merchant.passwordSecurity.maxLength
    "
  >
    <span class="yes icon">
      <i class="fas fa-check"></i>
    </span>
    <span class="no icon">
      <i class="fas fa-times"></i>
    </span>
    <span>
      {{
        "general.password.errors.maxLength"
          | translate: { value: cfg.merchant.passwordSecurity.maxLength }
      }}
    </span>
  </div>
  <div
    class="row categories"
    *ngIf="cfg.merchant.passwordSecurity.minCategories > 0"
    [class.success]="
      password && categories >= cfg.merchant.passwordSecurity.minCategories
    "
  >
    <span class="yes icon">
      <i class="fas fa-check"></i>
    </span>
    <span class="no icon">
      <i class="fas fa-times"></i>
    </span>
    <span>
      {{
        "general.password.errors.minCategories"
          | translate: { value: cfg.merchant.passwordSecurity.minCategories }
      }}
    </span>
  </div>
</ng-container>
